import axios from 'axios'
import { BFFAgent } from '../../BFFAgent'
import { deepFreeze } from '../../../features/common/Utilities'
import { PRESUPUESTADOR_ENDPOINT } from 'cfgCommon/endpoints'

export async function getPresupuesto(id, params, perfil) {
  const presupuesto = await axios(`${PRESUPUESTADOR_ENDPOINT}/${id}`).then((res) => res.data.data)

  const [cliente, auto] = await Promise.all([
    BFFAgent.Clients.getCliente(presupuesto.client_id),
    BFFAgent.Catalogs.getAutoFull(presupuesto.catalog_id, '', {
      perfil,
    }),
  ])

  presupuesto.cliente = cliente
  presupuesto.auto = auto
  return deepFreeze(presupuesto)
}
